<template>
  <div class="sidenav-divider"></div>
</template>

<script>
export default {
  name: 'SidenavDivider',
};
</script>
